/**
 * Created by lihanying on 2017/7/6.
 */

export const GETCLUBDEPLOYLIST = 'GETCLUBDEPLOYLIST'
export const GETDEPLOYINFO = 'GETDEPLOYINFO'



// WEBPACK FOOTER //
// ./src/containers/ClubDeploy/constants.js